import React from 'react';
import { Box } from '@material-ui/core';

export const TemporaryChatIcon = ({ size = 20, active = false, ...other }) => (
  <Box
    component="span"
    className={active ? 'ai--temporary-chat-active' : 'ai--temporary-chat'}
    sx={{ width: size, height: size, color: 'inherit', ...other.sx }}
  />
);

export const NoTrainingIcon = ({ size = 20, ...other }) => (
  <Box
    component="span"
    className="ai--no-training"
    sx={{ width: size, height: size, color: 'inherit', ...other.sx }}
  />
);

export const MemoryOffIcon = ({ size = 20, ...other }) => (
  <Box
    component="span"
    className="ai--memory-off"
    sx={{ width: size, height: size, color: 'inherit', ...other.sx }}
  />
);

export const VoiceWaveIcon = ({ size = 20, color = 'white' }) => (
  <Box
    component="span"
    className="ai--voice-wave"
    sx={{
      width: size,
      height: size,
      color: color,
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}
  />
);
